import React from 'react';
interface QuotationTotalsProps {
  subtotal: number;
  tax: number;
  grandTotal: number;
  currency: string;
}
export function QuotationTotals({
  subtotal,
  tax,
  grandTotal,
  currency
}: QuotationTotalsProps) {
  const formatCurrency = (amount: number) => {
    return amount.toFixed(2);
  };
  return <div className="flex justify-end mb-6" data-id="element-959">
      <div className="bg-neutral-50 border border-neutral-200 rounded-lg p-5 min-w-[320px] shadow-sm" data-id="element-960">
        <div className="space-y-2.5" data-id="element-961">
          <div className="flex justify-between items-center" data-id="element-962">
            <span className="text-xs font-medium text-neutral-600" data-id="element-963">
              Subtotal:
            </span>
            <span className="text-xs text-neutral-900 tabular-nums" data-id="element-964">
              {currency} {formatCurrency(subtotal)}
            </span>
          </div>

          <div className="flex justify-between items-center" data-id="element-965">
            <span className="text-xs font-medium text-neutral-600" data-id="element-966">Tax:</span>
            <span className="text-xs text-neutral-900 tabular-nums" data-id="element-967">
              {currency} {formatCurrency(tax)}
            </span>
          </div>

          <div className="h-px bg-neutral-300" data-id="element-968" />

          <div className="flex justify-between items-center bg-blue-50 border border-blue-200 -mx-5 px-5 py-2.5 rounded" data-id="element-969">
            <span className="text-sm font-bold text-neutral-900" data-id="element-970">
              Grand Total:
            </span>
            <span className="text-base font-bold text-blue-700 tabular-nums" data-id="element-971">
              {currency} {formatCurrency(grandTotal)}
            </span>
          </div>
        </div>
      </div>
    </div>;
}